export const rootlink = '/mw_v2/viewlist/';

export const blue = '#3591ea';
export const brown = '#873e23';

export const URL_MW = "https://www.manyw.com/";
export const thumbnailConfig = {width:1280,height:960};  //{width:320,height:180};
export const imgConfig = {width:640,height:400};
export const default_config = {
	region:[],
	bldg:[],
	price_hidden:{from:0,to:2000}, //this is for <Label> and Label color 
	price:{from:0,to:2000},
	rent:{from:0,to:20000},
	plate:[],
	order:"updatetime desc",
	net:{from:0,to:2000},
	room:[],
	floor:[],
	price_type:'free',
	buyrent:'buy',
	v720:false,
	pet:false,
	age:[],
	proptype: [],
};

export const default_viewinfo = JSON.parse('{"result":true,"data":[{"auto_no":"xx","bldg":"","flat":"","floor":"","cover_img":""}]}');
for (var i=1;i<=12;i++){
	let t = JSON.parse(JSON.stringify(default_viewinfo['data'][0]));
	t['auto_no'] = 'xx'+i;
	default_viewinfo['data'].push(t);
}

export const default_photolist = null;
export const default_planlist = null;
export const default_branchlist = null;


export const iphonechrome = /(iPhone).*CriOS/.test(navigator.userAgent);

export const thumbnailToImg = (x) => {
	x = x.replace('width='+thumbnailConfig.width, 'width='+imgConfig.width);
	x = x.replace('height='+thumbnailConfig.height, 'height='+imgConfig.height);
	return x;
}

